import type { State } from '../../types.tsx';

export const isCopyFilterModalOpen = (state: State): boolean =>
	state.copyFilterModal.isCopyFilterModalOpen;
